module.exports = __webpack_public_path__ + "img/17_95.98810e66.png";